/* eslint-disable */
import React from "react";
import UserStore from "./User";
import CompanyStore from "./Company";
import PermissionStore from "./Permission";
import BreadcrumbStore from "./Breadcrumb";
import MiscStore from "./Misc";
import ConversionRatesStore from "./ConversionRates";

const RootStore = {
  user: new UserStore(),
  company: new CompanyStore(),
  misc: new MiscStore(),
  permission: new PermissionStore(),
  breadcrumb: new BreadcrumbStore(),
  conversionRates: new ConversionRatesStore(),
};

const RootContext = React.createContext<typeof RootStore>(RootStore);

const useRootStore = (): typeof RootStore => React.useContext(RootContext);

export default function getRootStore(): typeof RootStore {
  return useRootStore();
}

export { RootStore, RootContext, getRootStore, useRootStore };
